module.exports = __webpack_public_path__ + "media/images/shared/laurel-portrait-e0d41b0ae5216ab5ae9ba67dcefb4e2c635a631e74ba710d88898309a89f8c48.jpg";